import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';

export default {
  props: {
    markets: {
      type: Array,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    dataNumColumnsDesktop: {
      type: Number,
      default: 3,
    },
    renderStyle: {
      type: Number,
      default: 1, // 1 = Tiles (default), 2 = Vertical List
    },
    trackingContext: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    marketListItem: marketListItemV2,
  },
  computed: {
    isVerticalList() {
      return this.renderStyle === 2;
    },
    gridStyleModifiers() {
      const n = this.dataNumColumnsDesktop;
      const gapTotal = (n - 1) * 20;
      return {
        'grid-template-columns': `repeat(auto-fit, minmax(max(300px, calc((100% - ${gapTotal}px) / ${n})), 1fr))`,
      };
    },
  },
};
